import { AsiDialogView } from "@asi-ngtools/lib";
import { Component } from "@angular/core";
import { FormGroup } from "@angular/forms";
import * as moment from "moment";

@Component({
  selector: 'modal-component',
  templateUrl: './modal.component.html',
})
export class ModalComponent extends AsiDialogView {
  public messageForm: FormGroup;
  public message: string;
  public code: string;

  constructor() {
    super();
  }

  isMiseEnAvant(): boolean {

    if (this.messageForm.value.miseEnAvant != null) {
      return this.messageForm.value.miseEnAvant;
    }
    return false;
  }

  formatDate(date: Date): string {
    return moment(date).format("DD/MM/YYYY");
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-notifications/digicerba-notifications-web/src/angular/cerba/src/app/pages/cerba/pages/alertes/message/publication/modal/modal.component.ts